import { commonUtils } from '@/helpers/commonUtils'
import PdfPage, { PageHeader } from '../PdfPage/PdfPage'
import styles from './PdfPageMomentAdvantage.module.less'
import MarkdownRenderer from '@/components/MarkdownRenderer/MarkdownRenderer'
import cls from 'classnames'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSize } from 'ahooks'
interface Props {
  advantage: string
  disadvantage: string
  onRendered: () => void
  project: ProjectModels.ProjectDetail
  no: number
}

function PdfPageMomentAdvantage(props: Props) {
  const { t } = useTranslation()
  const BOX_MAX_HEIGHT = 675
  const advantageRef = useRef<HTMLDivElement>(null)
  const disadvantageRef = useRef<HTMLDivElement>(null)
  // const [fontsize, setFontsize] = useState<number>(24)
  const [ratio, setRatio] = useState(1)

  const advantageSize = useSize(advantageRef.current)
  const disadvantageSize = useSize(disadvantageRef.current)


  // useEffect(() => {
  //   props.onRendered()
  //   if (advantageRef.current && disadvantageRef.current) {
  //     const adHeight = advantageRef.current.getBoundingClientRect().height
  //     const disHeight = disadvantageRef.current.getBoundingClientRect().height
  //     const bothMaxHeight = Math.max(adHeight, disHeight)
  //     if (bothMaxHeight > BOX_MAX_HEIGHT) {
  //       const ratio = BOX_MAX_HEIGHT / bothMaxHeight
  //       setFontsize(ratio * 24)
  //     }
  //   }
  // }, [])

  useEffect(() => {
    if (advantageSize && disadvantageSize) {
      const adHeight = advantageSize.height
      const disHeight = disadvantageSize.height
      const bothMaxHeight = Math.max(adHeight, disHeight)
      if (bothMaxHeight > BOX_MAX_HEIGHT) {
        setRatio(ratio => ratio - 0.1)
      } else {
        props.onRendered()
      }
    }
  }, [advantageSize, disadvantageSize])

  return (
    <PdfPage bgSrc={commonUtils.getImagePath('PDFDownload/pdf-page-9/PDF-bg-9.jpg')} no={props.no}>
      <div className={styles.pdfPageMomentAdvantage}>
        <PageHeader
          project={props.project}
          text={'03.' + t('dashboard.projectDetailPage.detailAnalysis')}
        />
        <div className={styles.content}>
          <div className={styles.contentInner}>
            <div className={styles.item}>
              <div className={styles.itemInner}>
                <div className={styles.title}>
                  <img src={commonUtils.getImagePath('PDFDownload/advantage-icon.png')} alt='' />
                  <span>{t('dashboard.projectDetailPage.storyboardView.advantages')}</span>
                </div>
                <div className={styles.advantage} ref={advantageRef}>
                  <MarkdownRenderer style={{ fontSize: 24 * ratio }} markdownText={props.advantage} />
                </div>
              </div>
            </div>

            <div className={styles.item}>
              <div className={styles.itemInner}>
                <div className={cls(styles.title, styles.disadvantageTitle)}>
                  <img src={commonUtils.getImagePath('PDFDownload/disadvantage-icon.png')} alt='' />
                  <span>{t('dashboard.projectDetailPage.storyboardView.disadvantages')}</span>
                </div>
                <div className={cls(styles.advantage, styles.disadvantage)} ref={disadvantageRef}>
                  <MarkdownRenderer
                    style={{ fontSize: 24 * ratio }}
                    markdownText={props.disadvantage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PdfPage>
  )
}

export default PdfPageMomentAdvantage
